// removed by extract-text-webpack-plugin
module.exports = {"ScreenXXSMax":"(max-width: 543px)","Bluecheese":"#615CFF","list":"G8a163f","item":"G102521"};